export default __webpack_public_path__ + "static/media/img_filterNoData_line.18448773.svg";